/*
 * iLOLA - GWP gift guard (Oct 2026)
 * ----------------------------------------------------------------------
 * WHY THIS FILE EXISTS
 * The Oct GWP Smart Cart (Rebuy 37612) has two gift tiers: spend $130 -> 5-Pack
 * Tasting Flight, spend $150 -> 10-Pack Tasting Flight. Rebuy is meant to swap the
 * lower gift out when the higher tier unlocks, but when a cart jumps past both
 * thresholds at once (e.g. quantity 1 -> 2) Rebuy's own removal can fail (Shopify
 * answers its cart update with 'updates parameter is invalid') and BOTH gift lines
 * stay in the cart. Shopify then only discounts one of them (non-Plus store: one
 * product discount per order), so the customer is charged for the 5-Pack gift.
 *
 * WHAT IT DOES
 * If the cart holds a Rebuy Tiered Progress Bar gift for the 10-Pack AND one for the
 * 5-Pack, it removes the 5-Pack gift line with a plain Shopify cart change and then
 * asks Rebuy to re-read the cart so the Smart Cart drawer matches. Only lines
 * carrying Rebuy's own _attribution property are ever touched, so a 5-Pack the
 * customer bought is safe.
 *
 * SAFETY
 * - Waits SETTLE_MS and must see the same conflict twice, so Rebuy's own cleanup
 *   always gets first go.
 * - At most MAX_REMOVALS removals per page load, so it can never loop with Rebuy.
 * - No MutationObserver and no polling: it only runs after a cart add/change/update/
 *   clear request, after Rebuy's own cart.change event, and once on page load (only
 *   when a cart cookie exists).
 * - Any error is swallowed; the worst case is that it does nothing.
 * - window.__ilolaGwpGuardLog records what it saw/did, for support/debugging.
 *
 * TO REMOVE: delete the render line in snippets/ilola-customer-state.liquid and this file.
 */
(function () {
  'use strict';
  if (window.__ilolaGwpGuard || !window.fetch) return;
  window.__ilolaGwpGuard = true;

  var nativeFetch = window.fetch.bind(window);
  var SETTLE_MS = 1500;
  var MAX_REMOVALS = 3;
  var removals = 0;
  var timer = null;
  var lastSig = '';
  var LOG = window.__ilolaGwpGuardLog = [];
  function log(msg) { try { if (LOG.length < 40) LOG.push(Math.round(performance.now()) + 'ms ' + msg); } catch (e) {} }

  function nameOf(item) {
    return String((item && (item.product_title || item.title)) || '');
  }
  function isRebuyGift(item) {
    var p = item && item.properties;
    return !!(p && p._attribution && /tiered progress bar/i.test(String(p._attribution)));
  }
  function isTen(item) { return /(^|[^0-9])10-Pack/i.test(nameOf(item)); }
  function isFive(item) { return /(^|[^0-9])5-Pack/i.test(nameOf(item)); }

  function removeLines(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (r) { log('change.js status ' + r.status); });
      });
    }, Promise.resolve()).then(function () {
      try {
        var R = window.Rebuy;
        if (R && R.Cart && typeof R.Cart.fetchCart === 'function') { R.Cart.fetchCart(); log('called Rebuy.Cart.fetchCart'); }
      } catch (e) { log('fetchCart error ' + e); }
    });
  }

  function check() {
    timer = null;
    nativeFetch('/cart.js?gwpguard=' + Date.now(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(isRebuyGift);
        var fives = gifts.filter(isFive);
        var hasTen = gifts.some(isTen);
        if (!hasTen || !fives.length) { lastSig = ''; return; }
        var keys = fives.map(function (i) { return i.key; });
        var sig = keys.join('|');
        if (sig !== lastSig) { lastSig = sig; log('conflict seen once, waiting'); schedule(); return; }
        if (removals >= MAX_REMOVALS) { log('removal cap reached'); return; }
        removals++;
        lastSig = '';
        log('conflict confirmed, removal attempt ' + removals);
        return removeLines(keys);
      })
      .catch(function (e) { log('check error ' + e); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, SETTLE_MS);
  }

  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1) {
        promise.then(schedule, function () {});
      }
    } catch (e) {}
    return promise;
  };

  document.addEventListener('rebuy:cart.change', schedule);

  function initial() {
    if (document.cookie.indexOf('cart=') > -1) schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial);
  } else {
    initial();
  }
})();
